import React from "react";
import Slider from "react-slick"; // Import react-slick
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const BackgroundMagicSlider = () => {
  // Slider settings
  const settings = {
    dots: false, // Show dots navigation
    infinite: true, // Infinite scroll
    speed: 3000, // Transition speed
    slidesToShow: 1, // Only show one slide at a time
    slidesToScroll: 1, // Scroll one slide at a time
    autoplay: true, // Auto-slide enabled
    autoplaySpeed: 2000, // Auto-slide interval (3 seconds)
    fade: true, // Use fade transition for a smooth background change
  };

  // Background images and content
  const slides = [
    {
      title: "Pioneering Transformation Beyond Boundaries",
      content: "Breaking Limits, Shaping the Future with Innovation",
      link: "https://ktig.info/about-ktig",
    },
    {
      title: "Your Trusted Path to Financial Success",
      content: "We Support Your Financial Growth with Smart Solutions",
      link: "https://www.kovaitechnidhi.com/",
    },
    {
      title: "Developing Skills to Strengthen Futures",
      content: "BR Academy - The Modern Approach to Training",
      link: "https://www.bracadmy.com/",
    },
    {
      title: "Transform Your Business with BNR Cogniitec",
      content: "Driving Digital Adoption Through BNR Cogniitec",
      link: "https://cogniitec.com/",
    },
    {
      title: " KTMC Connects the Chapters of Success",
      content: "KTIG Connects Future Through Simplified Technology",
      link: "/kovai-tech-member-chamber",
    },
  ];

  return (
    <div
      className="slider-container"
      style={{ width: "100%", height: "100vh", overflow: "hidden" }}
    >
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div
            key={index}
            className="slide"
            style={{
              backgroundImage: `url(${slide.background})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: "100vh", // Full viewport height
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "white",
              textShadow: "2px 2px 5px rgba(0, 0, 0, 0.7)", // Text shadow for readability
              position: "relative",
            }}
          >
            <div style={{ textAlign: "center", zIndex: 1 }}>
              <h2 style={{ fontSize: "3rem", fontWeight: "bold" }}>
                {slide.title}
              </h2>
              <p style={{ fontSize: "1.5rem" }}>{slide.content}</p>
              <a className="bannercta " href={slide.link}>
                Read More
              </a>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default BackgroundMagicSlider;
